<template>
    <div>
        <!-- get sales-advisor-permissions loading -->
        <div style="height:200px;" v-show="getSAPermissionsLoading">
            <pulse-loader
                :color="'#5e72e4'"
                :margin="'10px'"
                :size="20"
                style="position:absolute;top:50%;left:50%;transform:translate(-50%,50%)" />
        </div>

        <div class="table-responsive" v-show="!getSAPermissionsLoading">
            <base-table class="table align-items-center table-flush"
                thead-classes="thead-light"
                tbody-classes="list"
                :data="salesAdvisorPermissions"
            >
                <template slot="columns">
                    <th>permiso</th>
                    <th>estado</th>
                    <th></th>
                </template>

                <template slot-scope="{ row }">
                    <td>
                        {{ row.attributes.program_name }}
                    </td>

                    <td>
                        <pulse-loader
                            :loading="row.updateLoading || false"
                            :color="'#5e72e4'"
                            :margin="'2px'"
                            :size="10"
                        />

                        <span
                            :class="row.attributes.status === 'activado' ? 'text-green' : 'text-red'"
                            v-show="!row.updateLoading || false"
                        >
                            {{ row.attributes.status }}
                        </span>
                    </td>

                    <td class="text-right">
                        <b-form-checkbox
                            switch
                            size="sm"
                            :checked="row.attributes.status === 'activado' ? true : false"
                            @change="(e) => updatePermissionStatus(row, e)"
                            :disabled="row.updateLoading || false"
                        ></b-form-checkbox>
                    </td>
                </template>
            </base-table>
        </div>
    
    </div>
</template>

<script>
import { getSalesAdvisorSalesAdvisorPermissions, updateSalesAdvisorSalesAdvisorPermissions } from '@/api/SalesAdvisor/SalesAdvisorSalesAdvisorPermission'
//import { PulseLoader } from '@saeris/vue-spinners'

export default {
    name: 'ManageSAPermissions',
    props: {
        salesAdvisorId: {
            type: Number
        }
    },
    //components: { PulseLoader },
    data: () => ({
        salesAdvisorPermissions: [],
        //
        getSAPermissionsLoading: false
    }),
    created () {
        this.getSAPermissions()
    },
    methods: {
        getSAPermissions () {
            this.getSAPermissionsLoading = true

            getSalesAdvisorSalesAdvisorPermissions(this.salesAdvisorId)
                .then(({data}) => {
                    console.log('SAPermissions data: ' ,data);
                    this.salesAdvisorPermissions = data.data
                })
                .catch(err => {
                    console.log('SAPermissions err', err)
                    console.log('SAPermissions err.response', err.response)
                })
                .finally(() => {
                    this.getSAPermissionsLoading = false
                    console.log('request SAPermissions end')
                })
        },

        updatePermissionStatus (pSAPermission, event) {
            this.$set(pSAPermission, "updateLoading", true);

            let UpdateFormData = new FormData()
            UpdateFormData.append('.method', 'put')

            if (event) UpdateFormData.append('process', 'activar')
            else UpdateFormData.append('process', 'desactivar')

            updateSalesAdvisorSalesAdvisorPermissions(
                UpdateFormData,
                pSAPermission.attributes.salesAdvisor_id,
                pSAPermission.attributes.id)
                .then(({ data }) => {
                    console.log('update SAPermission status : ', data);
                    pSAPermission.attributes.status = data.data.attributes.status
                })
                .catch(err => {
                    console.log('update SAPermission status error: ', err);
                })
                .finally(() => {
                    pSAPermission.updateLoading = false
                })
        }
    }
}
</script>